import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from '../Reducer/RootReducer';
import domainMiddleware from '../../middleware/domainMiddleware';

const store = createStore(rootReducer, applyMiddleware(thunk,domainMiddleware));

export default store;